import { type ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "@/components/base/BackToTop";
import ScrollToTop from "./ScrollToTop";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <Header />
      <main>{children}</main>
      <Footer />
      <BackToTop />
    </div>
  );
}